"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userMocks = void 0;

var _msw = require("msw");

var getUserMock = _msw.rest.get('/enterprise/user', function (req, res, ctx) {
  return res(ctx.json({
    success: true,
    user: {
      id: 19985,
      first_name: 'Firstname',
      last_name: 'Lastname',
      country_id: 1,
      avatar: 'https://qa.alycedev.com/images/avatar.png',
      organisation_id: 1451,
      email: 'test@alyce.com',
      company: '',
      joinedAt: '2020-10-15 07:10:48',
      can_manage_teams: [2741],
      default_team: {
        id: 2741,
        name: 'Test team',
        settings: {
          country_id: 1,
          currency_id: 1,
          enterprise_mode_enabled: true
        }
      },
      organisation: {
        id: 1451,
        name: 'Test org',
        usingDKIM: false,
        canUseChromeExtension: 1
      },
      timezone: 'America/New_York'
    }
  }));
});

var userMocks = [getUserMock];
exports.userMocks = userMocks;